import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ELoadingActionTypes {
  SetPageLoader = 'LOADING/SET_PAGE_LOADER',
}

export type TSetPageLoader = ITypedReduxAction<ELoadingActionTypes.SetPageLoader, boolean>;

export const setPageLoader: (pageLoader: boolean) => TSetPageLoader = actionGenerator<
  ELoadingActionTypes.SetPageLoader,
  boolean
>(ELoadingActionTypes.SetPageLoader);

export type TLoadingActionTypes = TSetPageLoader;
